import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Willows",
  "description": "",
  "published": "2007-06-11T00:00:00.000Z",
  "redirect_from": ["/blog/the-willows/swizec/192"],
  "categories": "review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wow, continuing with saying the things that must be said took a longer gap in the chronos than anticipated. Anyway, onward on our quest to world domination.`}</p>
    <p><a parentName="p" {...{
        "href": "http://thewillowsmagazine.com/"
      }}>{`The Willows`}</a>{` is a magazine that had put out its first issue not long ago, and I ordered it on the very first day. Sadly it took a bit longer than that to arrive due to some mistakes on their side and the fact that the shipping system wasn't even set up yet when they were already taking orders, but I don't blame them, I didn't have time to read it even when it did arrive.`}</p>
    <p>{`The issue bolstered a lovely black exterior with nice white imagery and lettering, it was instantly enticing and captivating. Reading it took me right back to the days of reading Lovecraft and Poe, even though Poe doesn't technically fit the genre, whatever. The stories were a very nice pick, my compliments to the editor. The addition of short emphasised quotes contained within pages of each story was a nice touch I think and it really gave the magazine that late 19th century flare.`}</p>
    <p>{`My biggest favourite was the addition of one or two mock advertisements that seemed to fit perfectly into the time and coming upon them really brightened my day as they were set in a mocking tone to somethign that could actually come up in such a magazine back in the day. All in all, this was a nice revival of the forgotten genre and I will be buying issue two when it becomes available. I suggest everyone else to do the same.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      